export const onlyOwnerAccess = [1] // ['owner']
export const highAccessRoles = [1, 2] //['owner', 'administrator']
export const extendedAccessRoles = [1, 2, 3] //['owner', 'administrator', 'manager']
export const superAdminRoleId = 6 // super_admin (chargeback admin panel)
export const adminRoleId = 2 // admin (chargeback admin panel)
